import type React from 'react';

import { useRegion } from '@/hooks/useAppEnv';

import styles from './index.less';

interface WeChatDefaultBrowserOverlayProps {
  visible: boolean;
  onClose: () => void;
}

const WeChatDefaultBrowserOverlay: React.FC<WeChatDefaultBrowserOverlayProps> = ({
  visible,
  onClose
}) => {
  const { region } = useRegion();

  const isChinaMainland = region === 'cn';

  if (!visible) return null;

  return (
    <div className={styles.wechatOverlay} onClick={onClose}>
      <div className={styles.wechatInstructions}>
        <svg
          className={styles.wechatArrow}
          fill="none"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 80 Q 40 30, 85 15"
            fill="none"
            stroke="white"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </svg>
        <div className={styles.instructionRow}>
          <div className={styles.instructionText}>
            <span>{isChinaMainland ? '点击右上角' : 'Click top right'}</span>
            <span className={styles.instructionDots}>···</span>
            <span>{isChinaMainland ? '菜单' : 'menu'}</span>
          </div>
          <div className={styles.instructionNumber}>1</div>
        </div>
        <div className={styles.instructionRow}>
          <div className={styles.instructionText}>
            <span>{isChinaMainland ? '选择' : 'Select'}</span>
            <span className={styles.instructionBadge}>
              {isChinaMainland ? '在默认浏览器打开' : 'Open in Default Browser'}
            </span>
          </div>
          <div className={styles.instructionNumber}>2</div>
        </div>
      </div>
    </div>
  );
};

export default WeChatDefaultBrowserOverlay;
